export function clearSceneHoverPreviews({
  setHoverPreviewBody,
  setHoverPreviewJoint,
  setHoverPreviewMesh,
}) {
  setHoverPreviewBody(null);
  setHoverPreviewJoint(null);
  setHoverPreviewMesh(null);
}
